import React from "react";
import { ShieldAlert, LogOut } from "lucide-react";
import { useAuth } from "../lib/auth";
import { ChangePasswordForm } from "./ChangePasswordForm";

export const ForcePasswordChangeModal = () => {
  const { user, logout } = useAuth();
  if (!user?.must_change_password) return null;
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/80 backdrop-blur-md"
      data-testid="force-password-modal">
      <div className="glass-dark w-full max-w-lg rounded-2xl p-6 md:p-8 border border-red-500/30">
        <div className="flex items-center gap-3 mb-2">
          <div className="h-10 w-10 rounded-xl bg-red-500/15 border border-red-500/30 flex items-center justify-center">
            <ShieldAlert size={18} className="text-red-400" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-red-400 font-mono">Security</div>
            <h2 className="font-display font-bold text-xl">Set a new password</h2>
          </div>
        </div>
        <p className="text-sm text-zinc-400 mb-6">
          An admin reset your password. Enter the temporary password you received and choose a new one to continue.
        </p>
        <ChangePasswordForm currentLabel="Temporary password" idPrefix="force-pw" />
        <button onClick={logout} data-testid="force-pw-logout"
          className="mt-5 text-xs text-zinc-500 hover:text-zinc-300 inline-flex items-center gap-1.5 transition-colors">
          <LogOut size={12} /> Sign out instead
        </button>
      </div>
    </div>
  );
};
